import React from "react";
import { Link } from "react-router-dom";

/**
 * 404 fallback for unmatched routes (S-44).
 */
export default function NotFound() {
  return (
    <div role="main" style={{ padding: "64px 16px", textAlign: "center" }}>
      <h1 style={{ fontSize: "48px", marginBottom: "16px" }}>404</h1>
      <p style={{ marginBottom: "24px" }}>We can't find the page you're looking for.</p>
      <Link to="/dashboard">Back to dashboard</Link>
    </div>
  );
}
